import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyNoPhotoLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/noPhoto" */ './NoPhoto'), 'NoPhotoLayout');
